module.exports = __webpack_public_path__ + "static/media/lds-logo_km.578c9b37.svg";